var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "30%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(_vm.type.title))]),
      _vm.type.title === "批量恢复"
        ? _c(
            "div",
            { staticClass: "main" },
            [
              _c("p", [_vm._v("是否确认批量恢复如下员工账号")]),
              _vm._l(_vm.datas, function (item) {
                return _c("p", { key: item.id }, [
                  _vm._v(
                    _vm._s(item.loginAccount) +
                      " 生成时间： " +
                      _vm._s(item.createTime)
                  ),
                ])
              }),
              _c("p", [
                _vm._v("请注意，员工账户恢复为正常状态后，均为普通用户，若您"),
              ]),
              _c("p", [
                _vm._v("需要设置该员工为可接单的定制师账户，请在恢复权限"),
              ]),
              _c("p", [_vm._v("（普通用户）的编辑页面进行编辑。")]),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "main" },
            [
              _c("p", [_vm._v("是否确认批量停用如下员工账号：")]),
              _vm._l(_vm.datas, function (item) {
                return _c("p", { key: item.id }, [
                  _vm._v(
                    _vm._s(item.loginAccount) +
                      " 生成时间： " +
                      _vm._s(item.createTime) +
                      " "
                  ),
                ])
              }),
              _c("p", [
                _vm._v(
                  "请注意，员工账户停用后即无法再正常使用（请注意财务风险）。"
                ),
              ]),
            ],
            2
          ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.affirm } },
            [_vm._v(_vm._s(_vm.type.text))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }